<template>
	<Container class="bg-white">
		<div class="flex size-full flex-col justify-center bg-beige xl:flex-row">
			<div class="relative w-full xl:min-w-[470px]">
				<div
					class="relative size-full p-5 md:max-h-[612px] lg:p-6 xl:max-h-none"
				>
					<div
						class="relative flex aspect-[470/612] size-full items-center justify-center xl:aspect-[100%]"
					>
						<NuxtImg
							:src="curatedList?.creator_details.about.image_url"
							:alt="curatedList?.creator_details.name || ''"
							class="absolute inset-0 size-full object-cover object-[25%_90%] md:max-h-[612px] xl:max-h-none"
							sizes="(max-width: 1024px) 100vw, 470px"
							width="470"
							height="612"
							format="webp"
							quality="80"
							loading="lazy"
							preload
							fetchpriority="high"
						/>
						<NuxtImg
							v-if="curatedList?.creator_details.image_url"
							:src="curatedList?.creator_details.image_url"
							:alt="curatedList?.creator_details.name || ''"
							class="absolute left-10 top-10 size-[68px] rounded-full md:size-[92px]"
							format="webp"
							quality="80"
							loading="lazy"
							preload
							fetchpriority="high"
						/>
					</div>
				</div>
			</div>
			<div
				class="flex size-full max-w-full flex-col gap-y-6 px-5 pb-8 pt-6 lg:px-11 lg:pb-[52px] lg:pt-9"
			>
				<div class="w-full">
					<h2
						class="break-words font-matter-sq text-2xl font-normal leading-[150%] tracking-[-0.64px] text-primary xl:text-[32px]"
					>
						{{ curatedList?.creator_details.about.title }}
					</h2>
				</div>
				<div class="flex w-full flex-col gap-y-11">
					<div class="flex w-full flex-col gap-y-4">
						<p
							v-for="(paragraph, index) in curatedList?.creator_details.about
								.paragraphs"
							:key="`paragraph-${index}`"
							class="w-full break-words text-sm font-normal !leading-[200%] tracking-normal text-primary lg:text-base"
						>
							{{ paragraph }}
						</p>
					</div>
					<div
						class="flex flex-col items-start gap-x-16 gap-y-6 lg:flex-row lg:items-center"
					>
						<div class="flex items-start gap-x-4 gap-y-2 lg:flex-col">
							<p
								class="font-matter-sq text-[32px] font-normal leading-[150%] tracking-[-0.64px] text-primary"
							>
								{{ curatedList?.creator_details.about.followers }}
							</p>
							<span
								class="self-center text-sm font-medium leading-[28px] tracking-normal text-primary"
								>Seguidores</span
							>
						</div>
						<div class="flex items-start gap-x-4 gap-y-2 lg:flex-col">
							<p
								class="font-matter-sq text-[32px] font-normal leading-[150%] tracking-[-0.64px] text-primary"
							>
								{{ curatedList?.creator_details.about.posts }}
							</p>
							<span
								class="self-center text-sm font-medium leading-[28px] tracking-normal text-primary"
								>Publicações</span
							>
						</div>
						<div class="flex items-start gap-x-4 gap-y-2 lg:flex-col">
							<p
								class="font-matter-sq text-[32px] font-normal leading-[150%] tracking-[-0.64px] text-primary"
							>
								{{ curatedList?.creator_details.about.yearsOfExperience }}
							</p>
							<span
								class="self-center text-sm font-medium leading-[28px] tracking-normal text-primary"
								>Anos de experiência</span
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<script lang="ts" setup>
import type { CuratedList } from '~~/core/entities/CuratedList';

defineProps<{
	curatedList?: CuratedList;
}>();
</script>
